import SiteSlider from '../components/elements/SiteSlider';

if (document.getElementById('main-page-slider')) {
  new Vue({
    el: '#main-page-slider',
    components: {
      SiteSlider
    },
  });
}
